import React from "react";
import { LuCircleCheck } from "react-icons/lu";

export default function TopBanner() {
  return (
    <div className="top-banner">
      <LuCircleCheck size={15} aria-hidden="true" />
      <span style={{ whiteSpace: "nowrap" }}>100 % lokal im Browser</span>
      <span className="top-banner-sep" aria-hidden="true">|</span>
      <span>Entwickelt in 🇦🇹</span>
    </div>
  );
}
